import { isMatching, match } from 'ts-pattern';

export const isConsumer = isMatching({
  type: 'consumer',
});

export const isOrganization = isMatching({
  type: 'organization',
});

type IsConsumerOrOrganization = <
  T extends { type: 'consumer' | 'organization' },
>(
  param: T,
  consumerFn: (data: T) => void,
  organizationFn: (data: T) => void,
) => void;

export const isConsumerOrOrganization: IsConsumerOrOrganization = (
  param,
  consumerFn,
  organizationFn,
) =>
  match(param)
    .when(isConsumer, () => consumerFn(param))
    .when(isOrganization, () => organizationFn(param))
    .otherwise(() => null);
